// =============================================================================
// File: frontend/src/components/TrialToast.jsx
// Gentle, throttled trial reminder that rises from the SBM bottom (where status/
// credits live). Replaces the persistent TrialBanner. Shows at most a couple of
// times per day and auto-dismisses — informs without nagging. No subscribe CTA:
// upgrading lives only in the Account tab (clicking the toast routes there).
// Patent claims exercised: P-007 Claims 1-2
// =============================================================================

import React, { useState, useEffect } from 'react';

const MAX_PER_DAY = 2;       // "only a couple times a day — not a nuisance"
const VISIBLE_MS = 6000;     // auto-dismiss after ~6s

function TrialToast({ user, onGoToAccount }) {
  const [show, setShow] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);

  useEffect(() => {
    if (!user || user.subscription_status !== 'trialing' || user.permanent_test_acct || !user.trial_ends_at) return;

    const days = Math.max(0, Math.ceil((new Date(user.trial_ends_at) - new Date()) / 86400000));
    setDaysRemaining(days);

    // Throttle to MAX_PER_DAY appearances per calendar day (persisted across reloads).
    const today = new Date().toISOString().slice(0, 10);
    const key = 'healist_trial_toast';
    let rec = {};
    try { rec = JSON.parse(localStorage.getItem(key)) || {}; } catch { rec = {}; }
    const count = rec.date === today ? (rec.count || 0) : 0;
    if (count >= MAX_PER_DAY) return;
    localStorage.setItem(key, JSON.stringify({ date: today, count: count + 1 }));

    setShow(true);
    const t = setTimeout(() => setShow(false), VISIBLE_MS);
    return () => clearTimeout(t);
  }, [user]);

  if (!show) return null;

  return (
    <div
      className="trialToast"
      role="status"
      onClick={() => { if (onGoToAccount) onGoToAccount(); setShow(false); }}
    >
      <button
        className="trialToast-close"
        onClick={(e) => { e.stopPropagation(); setShow(false); }}
        title="Dismiss"
      >
        &#10005;
      </button>
      <div className="trialToast-days">
        {user?.is_beta ? '🧪 ' : ''}
        {daysRemaining === 1
          ? `1 day remaining of ${user?.is_beta ? 'your beta access' : 'free trial'}`
          : `${daysRemaining} days remaining of ${user?.is_beta ? 'your beta access' : 'free trial'}`}
      </div>
      <div className="trialToast-cta">
        {user?.is_beta ? 'Founding Member offer in Account Tab' : 'Visit Account Tab to Upgrade'}
      </div>
    </div>
  );
}

export default TrialToast;
